import React from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
} from "@mui/material";
import ConfirmacionDialog from "../components/newFormat/ConfirmacionDialog";
import IconBreadcrumbs from "../components/MigasDePan/MigasDePan";
import { columns } from "./constants";
import useImpresora from "./useImpresora";
import ToolbarCRUD from "../components/newFormat/ToolbarCRUD";
import TablaHeader from "../components/newFormat/TablaHeaderCRUD";
import { LoadingRow, EmptyRow } from "../components/newFormat/TableEmptyStates";
import { tableContainerSx } from "../components/newFormat/styles";
import RowNuevo from "./Componentes/RowNuevo";
import RowEditar from "./Componentes/RowEditar";
import RowImpresora from "./Componentes/RowImpresora";

const Impresora = () => {
  const {
    rows,
    pagination,
    page,
    rowsPerPage,
    search,
    buscando,
    input,
    orden,
    cargando,
    openNuevo,
    nuevo,
    guardando,
    errores,
    editandoId,
    editando,
    erroresEdit,
    eliminando,
    confirmDelete,
    highlightId,
    highlightType,
    totalPages,
    setSearch,
    setOpenNuevo,
    setNuevo,
    setErrores,
    setEditando,
    setErroresEdit,
    handleSearch,
    handleSort,
    handleChangePage,
    handleChangeRowsPerPage,
    handleRefresh,
    handleClearSearch,
    handleRegistrar,
    handleCancelNuevo,
    handleIniciarEditar,
    handleActualizar,
    handleCancelEditar,
    handleEliminar,
    handleConfirmDelete,
    setConfirmDelete,
  } = useImpresora();

  return (
    <Box p={1}>
      <IconBreadcrumbs />

      <ToolbarCRUD
        labelAgregar="Agregar impresora"
        placeholderBuscar="Buscar por nombre o IP..."
        search={search}
        setSearch={setSearch}
        buscando={buscando}
        onSearch={handleSearch}
        onClearSearch={handleClearSearch}
        onRefresh={handleRefresh}
        onNuevo={() => setOpenNuevo(true)}
        cargando={cargando}
        openNuevo={openNuevo}
        editandoId={editandoId}
        pagination={pagination}
        page={page}
        totalPages={totalPages}
        rowsPerPage={rowsPerPage}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />

      <TableContainer component={Paper} elevation={0} sx={tableContainerSx}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TablaHeader
              columns={columns}
              cargando={cargando}
              input={input}
              orden={orden}
              onSort={handleSort}
            />
          </TableHead>
          <TableBody>
            {openNuevo && (
              <RowNuevo
                nuevo={nuevo}
                setNuevo={setNuevo}
                errores={errores}
                setErrores={setErrores}
                onGuardar={handleRegistrar}
                onCancelar={handleCancelNuevo}
                guardando={guardando}
              />
            )}
            {!rows ? (
              <LoadingRow colSpan={columns.length + 1} />
            ) : rows.length === 0 ? (
              <EmptyRow colSpan={columns.length + 1} />
            ) : (
              rows.map((row, idx) => {
                const isEditing = editandoId === row.imp_id;
                return isEditing ? (
                  <RowEditar
                    key={row.imp_id}
                    editando={editando}
                    setEditando={setEditando}
                    erroresEdit={erroresEdit}
                    setErroresEdit={setErroresEdit}
                    onGuardar={handleActualizar}
                    onCancelar={handleCancelEditar}
                    guardando={guardando}
                  />
                ) : (
                  <RowImpresora
                    key={row.imp_id}
                    row={row}
                    idx={idx}
                    eliminando={eliminando}
                    onEditar={() => handleIniciarEditar(row)}
                    onEliminar={() => handleEliminar(row.imp_id)}
                    highlightId={highlightId}
                    highlightType={highlightType}
                  />
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <ConfirmacionDialog
        open={confirmDelete.open}
        onClose={() => setConfirmDelete({ open: false, id: null })}
        onConfirm={handleConfirmDelete}
        titulo="¿Eliminar impresora?"
      />
    </Box>
  );
};

export default Impresora;
